(function() {
  'use strict';

  angular.module('app.parcels')
    .controller('WorkflowCtrl', WorkflowCtrl);

  /** @ngInject */
  function WorkflowCtrl($templateCache, $window, sessionService, $rootScope, $scope, $filter, $document, $state, $uibModal, $timeout, maps, NgTableParams, Parcels, reportdata, Reports) {
    let vm = this;
    vm.startPage = true;
    vm.workflowRec = false;
    vm.workflowFinalList = false;
    vm.workflowReconcile = false;
    vm.workflowUpload = false;
    vm.createTractsArea = false;
    vm.generateLettersFlag = false;
    vm.viewInspections = false;
    vm.generalBulkEditFlag = false;
    vm.importing = false;
    vm.completedImport = false;
    vm.showUndo = false;
    vm.undoing = false;
    vm.showUnmatched = false;
    vm.exportingUnmatched = false;
    vm.dateFormat = 'MM/dd/yyyy';
    vm.auctionDates = [];
    vm.csvErrorsPresent = false;
    vm.pinErrorsPresent = false;
    vm.missingFieldsPresent = false;
    vm.csvErrors = [];
    vm.pinErrors = [];
    vm.missingFields = [];
    // console.log('vm.checkeditems', vm.checkeditems);

    Parcels.getFutureAuctionDates(true).then(function(allAuctionDates) {
      vm.auctionDates = allAuctionDates;
    });

    vm.forsdate = {
      opened: false
    };
    vm.foredate = {
      opened: false
    };
    vm.fortractdate = {
      opened: false
    };

    vm.exporting = false;
    vm.selectedStep = '';
    vm.queryBtnHelpTxt = 'Toggle query visibility';

    $scope.$on('update-table-and-dates', function() {
      // refresh the list of dates and refresh the table of results
      // refresh the auction dates list
      vm.auctionDates = [];
      Parcels.getFutureAuctionDates(true).then(function(allAuctionDates) {
        vm.auctionDates = allAuctionDates;
      });
      // refresh the table of results
      Parcels.list(false);
    });

    vm.selected = {
      stepOne: false,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepFive: false,
      stepSix: false,
      stepSeven: false,
      stepEight: false
    };

    vm.iWantToChangedTo = function() {
      vm.startPage = false;
      vm.workflowRec = false;
      vm.workflowFinalList = false;
      vm.workflowReconcile = false;
      vm.generateLettersFlag = false;
      vm.createTractsArea = false;
      vm.workflowUpload = false;
      vm.viewInspections = false;
      vm.generalBulkEditFlag = false;
      switch (vm.selectedStep) {
        case 'stepOne':
          $rootScope.$broadcast('close-tract-option', false);
          vm.changeWorkflowUpload(vm.selectedStep);
          break;
        case 'stepEight':
          $rootScope.$broadcast('close-tract-option', false);
          vm.viewInspectionParcels(vm.selectedStep);
          break;
        case 'stepFive':
          $rootScope.$broadcast('close-tract-option', false);
          vm.createTracts(vm.selectedStep);
          break;
        case 'stepTwo':
          $rootScope.$broadcast('close-tract-option', false);
          vm.generateLetters(vm.selectedStep);
          break;
        case 'stepThree':
          $rootScope.$broadcast('close-tract-option', false);
          vm.changeWorkflowBoardRec(vm.selectedStep);
          break;
        case 'stepFour':
          $rootScope.$broadcast('close-tract-option', false);
          vm.changeWorkflowFinalAuctionList(vm.selectedStep);
          break;
        case 'stepSix':
          $rootScope.$broadcast('close-tract-option', false);
          vm.generateLetters(vm.selectedStep);
          break;
        case 'stepSeven':
          $rootScope.$broadcast('close-tract-option', true);
          vm.changeWorkflowReconcileAuction(vm.selectedStep);
          break;
        case 'outOfStep':
          $rootScope.$broadcast('close-tract-option', false);
          console.log('outOfStep');
          vm.generalBulkEdit(vm.selectedStep);
          break;
        default:
          vm.startPage = true;
          alert('Not Implemented Yet.');
          break;
      }
    };

    vm.generalBulkEdit = function(step) {
      vm.generalBulkEditFlag = true;
      $rootScope.$broadcast('bulkfields-changed', []);
      //  $rootScope.$broadcast('bulkfields-changed', ['Last_LS_date', 'PurchaseDate', 'Sold_type', 'TaxForfeitedStatus', 'Purch_price', 'Repurch_price']);
      _setSelected(step);
    };

    vm.changeWorkflowUpload = function(step) {
      $rootScope.$broadcast('bulkfields-changed', []);
      vm.workflowUpload = true;
      maps.clearAdminFilter();
      Parcels.clearParcels();
      _setSelected(step);
    };

    vm.generateLetters = function(step) {
      if (step === 'stepOne') {
        $rootScope.$broadcast('bulkfields-changed', []);
        $rootScope.$broadcast('letters-changed', ['ownerletter']);
        vm.workflowUpload = true;
      } else if (step === 'stepTwo') {
        $rootScope.$broadcast('bulkfields-changed', ['CityTwpResponse', 'DNRResponse', 'DNRResponse_Date', 'CityTwpResponse_Date', 'Notice_Date_TwpCity_Class', 'Notice_Date_DNR_Class']);
        $rootScope.$broadcast('letters-changed', ['dnrlandsalelist', 'dnrfutureletter', 'classLetter', 'citydirectsale', 'dnrfutureauction', 'adjacentletter']);
        maps.clearAdminFilter();
        Parcels.clearParcels();
        _setSelected(step);
      } else if (step === 'stepSix') {
        $rootScope.$broadcast('bulkfields-changed', []);
        $rootScope.$broadcast('letters-changed', ['radiusletter']);
        maps.clearAdminFilter();
        Parcels.clearParcels();
        _setSelected(step);
      }
      vm.generateLettersFlag = true;
    };

    // Step 5 on UI: Generate County Board Reports
    vm.changeWorkflowBoardRec = function(step) {
      console.log('vm.changeWorkflowBoardRec');
      $rootScope.$broadcast('bulkfields-changed', []);
      vm.workflowRec = true;
      // let today = new Date();
      // let query = {};
      // today.setMonth(today.getMonth() - 6);
      // query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND (CityTwpResponse = \'Approve\' OR CityTwpResponse = \'Approve by No Response\') AND DNRResponse = \'Approve\' AND Forfeiture_date <= \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND Tract IS NOT NULL';
      // maps.clearAdminFilter();
      // maps.setTractQuery(true);
      // maps.adminFilterProperties(query);
      // // get the tracts for this step
      // Parcels.list(true);
      _setSelected(step);
      $rootScope.$broadcast('set-query-indicator', {
        value: true
      });
    };

    vm.changeWorkflowFinalAuctionList = function(step) {
      // console.log('step', step);
      $rootScope.$broadcast('bulkfields-changed', ['Board_Class_Action', 'BoardClassAction_Date', 'ProposedSaleType', 'Last_LS_date']);
      vm.workflowFinalList = true;
      let today = new Date();
      let query = {};
      today.setMonth(today.getMonth() - 6);
      // vm.finalListDate = today;
      // vm.forfeitStatus = 'Active';
      vm.board = null;
      // vm.tract = 'IS NOT NULL';
      vm.dnrResponse = 'Approve';
      vm.cityResponse = '(Approve OR Approve by No Response)';
      query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND (CityTwpResponse = \'Approve\' OR CityTwpResponse = \'Approve by No Response\') AND DNRResponse = \'Approve\' AND Forfeiture_date <= date \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND Tract IS NOT NULL';
      _finalAuctionListQuery(query, step);

      //// Moved into _finalAuctionListQuery function
      // maps.clearAdminFilter();
      // maps.setTractQuery(true);
      // maps.adminFilterProperties(query);
      // // get the tracts for this step
      // Parcels.list(true);
      // _setSelected(step);
      // $rootScope.$broadcast('set-query-indicator', {
      //   value: true
      // });
    };

    function _finalAuctionListQuery(query, step) {
      // console.log(query.lastDate);
      maps.clearAdminFilter();
      maps.setTractQuery(true);
      maps.adminFilterProperties(query);
      // get the tracts for this step
      Parcels.list(true);
      _setSelected(step);
      $rootScope.$broadcast('set-query-indicator', {
        value: true
      });
    }

    vm.newFinalAuctionListQuery = function(step) {
      // construct the query to be passed to _finalAuctionListQuery
      let query = {};
      let wheres = [];
      let whereFields = [{
        field: 'Board_Class_Action',
        value: vm.board
      },{
        field: 'CityTwpResponse',
        value: vm.cityResponse
      },{
        field: 'DNRResponse',
        value: vm.dnrResponse
      }];
      for (let id in whereFields) {
        if (whereFields[id].value == null || whereFields[id].value === '') {
          wheres.push(whereFields[id].field + ' IS NULL');
        } else if (whereFields[id].value === '(Approve OR Approve by No Response)'){
          wheres.push('(CityTwpResponse = \'Approve\' OR CityTwpResponse = \'Approve by No Response\')');
        } else {
          wheres.push(whereFields[id].field + ' = \'' + whereFields[id].value + '\'');
        }
      }
      query.lastDate = wheres.join(' AND ');
      query.lastDate += ' AND TaxForfeitedStatus = \'Active\' AND Tract IS NOT NULL';
      console.log('query.lastDate', query.lastDate);
      _finalAuctionListQuery(query, step);
    };

    // Step 8 on the UI
    vm.changeWorkflowReconcileAuction = function(step) {
      $rootScope.$broadcast('bulkfields-changed', []);
      vm.workflowReconcile = true;
      _setSelected(step);
      maps.clearAdminFilter();
      Parcels.clearParcels();
      // set defaults
      vm.forfeitStatus = 'notInactive';
      vm.tract = 'notNull';
      vm.purchPrice = null;
      vm.soldType = null;
      // if returning to this step after selecting a different step
      // if (vm.auctionDate != null) {
      //   console.log('running here');
      //   let query = {};
      //   // TODO: double check this date query
      //   query.lastDate = 'Last_LS_date = \'' + vm.auctionDate + '\'';
      //   maps.clearAdminFilter();
      //   // maps.setTractQuery(true);
      //   maps.adminFilterProperties(query);
      //   // get the parcels for this step
      //   Parcels.list(false);
      // }
      $rootScope.$broadcast('set-query-indicator', {
        value: true
      });
    };

    vm.createTracts = function(step) {
      $rootScope.$broadcast('bulkfields-changed', []);
      vm.createTractsArea = true;
      let today = new Date();
      let query = {};
      // set default date to today minus six months
      today.setMonth(today.getMonth() - 6);
      vm.createTractDate = today;
      vm.forfeitStatus = 'Active';
      query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Forfeiture_date <= date \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND (Tract IS NULL OR Tract = \'\')';
      // second parameter indicates if the tracts should be set to the same query as the parcels
       _createTractsQuery(query, step);

      // //Moved below to _createTractsQuery function
      // maps.clearAdminFilter();
      // maps.setTractQuery(false);
      // maps.adminFilterProperties(query);
      // Parcels.list();
      // maps.setParcelsRenderer();
      // _setSelected(step);
      // $rootScope.$broadcast('set-query-indicator', {
      //   value: true
      // });
    };

    vm.newCreateTractsQuery = function() {
      let query = {};
      query.lastDate = 'TaxForfeitedStatus = \'' + vm.forfeitStatus + '\' AND Forfeiture_date <= date \'' + (vm.createTractDate.getMonth() + 1) + '/' + vm.createTractDate.getDate() + '/' + vm.createTractDate.getFullYear() + '\' AND (Tract IS NULL OR Tract = \'\')';
      console.log('where', query.lastDate);
      _createTractsQuery(query, 'stepFive');
    };

    function _createTractsQuery(query, step) {
      maps.clearAdminFilter();
      maps.setTractQuery(false);
      maps.adminFilterProperties(query);
      Parcels.list();
      maps.setParcelsRenderer();
      _setSelected(step);
      $rootScope.$broadcast('set-query-indicator', {
        value: true
      });
    }




    vm.viewInspectionParcels = function(step) {
      $rootScope.$broadcast('bulkfields-changed', []);
      vm.viewInspections = true;
      vm.forfeitStatus = 'Active';
      vm.inspection = 'Needs Inspection';
      vm.proposedSaleType = null;
      vm.board = null;
      vm.getInspectParcels(step);
      // let query = {};
      // query.lastDate = 'ProposedSaleType IS NULL AND TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND InspectionStatus = \'Needs Inspection\' AND Tract IS NULL';
      // maps.clearAdminFilter();
      // maps.setTractQuery(true);
      // maps.adminFilterProperties(query);
      // Parcels.list();
      // _setSelected(step);
      // $rootScope.$broadcast('set-query-indicator', {
      //   value: true
      // });
    };

    vm.getInspectParcels = function(step) {
    // function _getInspectParcels (step) {
      let query = {};
      let wheres = [];
      let whereFields = [{
        field: 'TaxForfeitedStatus',
        value: vm.forfeitStatus
      },{
        field: 'Board_Class_Action',
        value: vm.board
      },{
        field: 'InspectionStatus',
        value: vm.inspection
      },{
        field: 'ProposedSaleType',
        value: vm.proposedSaleType
      }];
      for (let id in whereFields) {
        if (whereFields[id].value == null || whereFields[id].value === '') {
          wheres.push(whereFields[id].field + ' IS NULL');
        } else {
          wheres.push(whereFields[id].field + ' = \'' + whereFields[id].value + '\'');
        }
      }
      query.lastDate = wheres.join(' AND ');
      console.log('query.lastDate', query.lastDate);
      // query.lastDate = 'ProposedSaleType IS NULL AND TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND InspectionStatus = \'Needs Inspection\' AND Tract IS NULL';
      maps.clearAdminFilter();
      maps.setTractQuery(true);
      maps.adminFilterProperties(query);
      Parcels.list();
      _setSelected(step);
      $rootScope.$broadcast('set-query-indicator', {
        value: true
      });
    };

    vm.exportToZillow = function() {
      alert('Export to Zillow Coming soon!');
    };

    vm.viewMap = function() {
      $rootScope.$broadcast('switch-to-map');
      $state.go('admin');
    };

    vm.exportBoardList = function() {
      console.log('export list');
      alert('Export list coming soon!');
    };

    vm.boardReportTitle = 'Board Report Type:';

    vm.boardRepTypes = [{
      name: 'Forfeiture Classification Recommendations',
      id: 'class-recs',
      description: '',
      layer: 'Parcels',
      query: 'Forfeiture_date = [date selected]',
      fields: {
        date: true,
        filetype: true
      }
    }, {
      name: 'Revalue Summary',
      id: 'revalue',
      description: '',
      layer: 'Parcels',
      query: 'Sold_type IS NULL AND Board_Class_Action = \'Non-Conservation\' AND TaxForfeitedStatus = \'Active\' AND Total_parcel_price IS NOT NULL\n (Then find parcels where land price or special assessment balance increased or decreased since Last_LS_date)',
      fields: {
        date: false,
        filetype: true
      }
    }, {
      name: 'Export Tract List'
    }];

    vm.boardReportType = function() {
      console.log('report type: ', vm.boardReportTitle);
      if (vm.boardReportTitle === 'Export Tract List') {
        if (vm.fileTypes.indexOf('PDF') > -1) {
          vm.fileTypes.splice(1, 1);
        }
      } else {
        if (vm.fileTypes.indexOf('PDF') === -1) {
          vm.fileTypes.push('PDF');
        }
      }
      // set query defaults
      if (vm.boardReportTitle === 'Forfeiture Classification Recommendations') {
        vm.forfeitStatus = 'Active';
      }
      else if (vm.boardReportTitle === 'Revalue Summary') {
        vm.forfeitStatus = 'Active';
        vm.board = 'Non-Conservation';
        vm.soldType = '';
        vm.totalPrice = 'notNull';
      }
      else if (vm.boardReportTitle === 'Export Tract List') {
        vm.board = '';
        vm.cityResponse = 'approveOrNoResponse';
        vm.dnrResponse = 'Approve';
      }
    };

    vm.params = {
      date: new Date(),
      filetype: ''
    };

    vm.formatTitle = 'Choose file format';

    vm.fileTypes = [
      'Excel',
      'PDF'
    ];

    vm.fileFormat = function() {
      console.log('file type: ', vm.fileType);
    };

    vm.openCalS = function() {
      vm.forsdate.opened = true;
    };

    vm.openCalE = function() {
      vm.foredate.opened = true;
    };

    vm.openCalCreateTracts = function() {
      vm.fortractdate.opened = true;
    };

    // not being used since making query filters dynamic
    // vm.changeAuctionDate = function() {
    //   console.log('changeAuctionDate');
    //   let query = {};
    //   // console.log(_formatDataBaseDate(vm.auctionDate));
    //   query.lastDate = 'Last_LS_date >= date \'' + _formatStartQueryDate(vm.auctionDate) + '\' AND Last_LS_date <= date \'' + _formatEndQueryDate(vm.auctionDate) + '\' AND Purch_price IS NULL AND Sold_type IS NULL AND TaxForfeitedStatus <> \'Inactive\' AND Tract IS NOT NULL';
    //   // maps.setTractQuery(true);
    //   maps.adminFilterProperties(query);
    //   // get the parcels for this step
    //   Parcels.list(false);
    // };

    vm.reconcileQuery = function() {
      console.log('reconcileQuery');
      let query = {};
      let wheres = [];
      wheres.push('Last_LS_date >= date \'' + _formatStartQueryDate(vm.auctionDate) + '\' AND Last_LS_date <= date \'' + _formatEndQueryDate(vm.auctionDate) + '\'');
      let whereFields = [{
        field: 'TaxForfeitedStatus',
        value: vm.forfeitStatus
      },{
        field: 'Purch_price',
        value: vm.purchPrice
      },{
        field: 'Sold_type',
        value: vm.soldType
      },{
        field: 'Tract',
        value: vm.tract
      }];
      for (let id in whereFields) {
        if (whereFields[id].value == null || whereFields[id].value === '') {
          wheres.push(whereFields[id].field + ' IS NULL');
        } else if (whereFields[id].value === 'notNull'){
          wheres.push(whereFields[id].field + ' IS NOT NULL');
        } else if (whereFields[id].value === 'notInactive') {
          wheres.push(whereFields[id].field + ' <> \'Inactive\'');
        } else {
          wheres.push(whereFields[id].field + ' = \'' + whereFields[id].value + '\'');
        }
      }
      query.lastDate = wheres.join(' AND ');
      console.log('query.lastDate', query.lastDate);
      maps.adminFilterProperties(query);
      // get the parcels for this step
      Parcels.list(false);
      console.warn(vm.auctionDates.value);
    };

    vm.submitBoardReport = function() {
      vm.exporting = true;
      if (vm.boardReportTitle == null || vm.fileType == null) {
        vm.exporting = false;
        alert('Please select a report type and format!');
      } else if (vm.boardReportTitle === 'Forfeiture Classification Recommendations') {
        // console.log('class-recs report will run');
        // console.log(_formatDate(vm.forfeitDate));
        if (vm.startDate != null || vm.endDate != null) {
          let params = {};
          params.startDate = _formatDate(vm.startDate);
          params.endDate = _formatDate(vm.endDate);
          params.filetype = vm.fileType;
          params.forfeitStatus = vm.forfeitStatus;
          console.log(params);
          reportdata.getClassRecsData(params).then(function(reportData) {
            if (reportData.length > 0) {
              console.log('reportData', reportData);
              params.reportData = reportData;
              Reports.classRec(params).then(function(results) {
                vm.exporting = false;
                if (results) {
                  window.open(window.location.origin + results);
                } else {
                  alert('There is no result found with the current filters!');
                }
              });
            } else {
              vm.exporting = false;
              alert('No parcels available for the date choosen.');
            }
          });
        } else {
          vm.exporting = false;
          alert('Please select both a start and end date!');
        }
      } else if (vm.boardReportTitle === 'Revalue Summary') {
        // console.log('revalue report will run');
        let wheres = [];
        let whereFields = [{
          field: 'TaxForfeitedStatus',
          value: vm.forfeitStatus
        },{
          field: 'Board_Class_Action',
          value: vm.board
        },{
          field: 'Sold_type',
          value: vm.soldType
        },{
          field: 'Total_parcel_price',
          value: vm.totalPrice
        }];
        for (let id in whereFields) {
          if (whereFields[id].value == null || whereFields[id].value === '') {
            wheres.push(whereFields[id].field + ' IS NULL');
          } else if (whereFields[id].value === 'notNull'){
            wheres.push(whereFields[id].field + ' IS NOT NULL');
          } else if (whereFields[id].value === 'notInactive') {
            wheres.push(whereFields[id].field + ' <> \'Inactive\'');
          } else {
            wheres.push(whereFields[id].field + ' = \'' + whereFields[id].value + '\'');
          }
        }
        let query = wheres.join(' AND ');
        console.log('query', query);
        let params = {};
        params.filetype = vm.fileType;
        // let params = _processParams();
        reportdata.getRevalueData(query).then(function(reportData) {
          console.log('Heres the report data ', reportData);
          if (reportData.length > 0) {
            params.reportData = reportData;
            Reports.revalue(params).then(function(results) {
              vm.exporting = false;
              if (results) {
                window.open(window.location.origin + results);
              } else {
                alert('There was an error generating the selected report.  Please try again.');
              }
            });
          } else {
            vm.exporting = false;
            alert('There is no result found with the current filters!');
          }
        });
      } else if (vm.boardReportTitle === 'Export Tract List') {
        let wheres = [];
        let whereFields = [{
          field: 'Board_Class_Action',
          value: vm.board
        },{
          field: 'DNRResponse',
          value: vm.dnrResponse
        },{
          field: 'CityTwpResponse',
          value: vm.cityResponse
        }];
        for (let id in whereFields) {
          if (whereFields[id].value == null || whereFields[id].value === '') {
            wheres.push(whereFields[id].field + ' IS NULL');
          } else if (whereFields[id].value === 'notNull'){
            wheres.push(whereFields[id].field + ' IS NOT NULL');
            // this will only happen with CityTwpResponse
          } else if (whereFields[id].value === 'approveOrNoResponse') {
            wheres.push('(CityTwpResponse = \'Approve\' OR CityTwpResponse = \'Approve by No Response\')');
          } else {
            wheres.push(whereFields[id].field + ' = \'' + whereFields[id].value + '\'');
          }
        }
        let query = wheres.join(' AND ');
        console.log('query', query);
          reportdata.getTractListData(query).then(function(reportData) {
            console.log('reportData', reportData);
            if (reportData.length > 0) {
              Reports.exportBoardList(reportData).then(function(results) {
            // Reports.exportBoardList(tracts.getTracts()).then(function(results) {
              vm.exporting = false;
              if (results) {
                window.open(window.location.origin + results);
              } else {
                alert('There was an error generating the selected report.  Please try again.');
              }
            });
          } else {
            vm.exporting = false;
            alert('There is no result found with the current filters!');
          }

          });

      }

    };

    vm.addNewParcels = function() {
      // console.log($scope.fileContent);
      vm.completedImport = false;
      if ($scope.fileContent != null) {
        vm.importing = true;
        Parcels.create($scope.fileContent).then(function(results) {
          vm.importing = false;
          vm.completedImport = true;
          vm.showUndo = true;
          vm.completeMessage = results.length + ' new tax forfeit parcels successfully added out of the ' + results.csvCount + ' parcel PIN\'s from the CSV file.';
          if (results.unmatchedCount > 0) {
            vm.showUnmatched = true;
          }
          if (results.csvErrors.length > 0) {
            vm.csvErrorsPresent = true;
            vm.csvErrors = results.csvErrors;
          }
          if (results.unmatchedCount > 0) {
            vm.pinErrorsPresent = true;
            vm.pinErrors = results.unmatchedPINs;
          }
          if (results.missingCsvFields.length > 0) {
            vm.missingFieldsPresent = true;
            vm.missingFields = results.missingCsvFields;
          }
          vm.generateLetters('stepOne');
        });
      } else {
        vm.completedImport = true;
        vm.completeMessage = 'Please choose a file to upload first!';
        $timeout(function() {
          vm.completedImport = false;
        }, 2000);
      }
    };

    vm.undoParcelUpload = function() {
      vm.undoing = true;
      vm.completedImport = false;
      vm.pinErrorsPresent = false;
      vm.csvErrorsPresent = false;
      vm.missingFieldsPresent = false;
      Parcels.undoUpload().then(function() {
        angular.element("input[type='file']").val(null); // jshint ignore:line
        $scope.fileContent = null;
        vm.generateLettersFlag = false;
        vm.undoing = false;
        vm.showUndo = false;
        vm.workflowUpload = true;
        vm.viewInspections = false;
      });
    };

    vm.printUnmatchedList = function() {
      // console.log('print unmatched parcel list');
      let unmatchedList = Parcels.getUnmatchedList();
      vm.exportingUnmatched = true;
      Reports.exportUnmatchedList(unmatchedList).then(function(results) {
        vm.exportingUnmatched = false;
        if (results) {
          window.open(window.location.origin + results);
        } else {
          alert('There is no result found with the current filters!');
        }
      });
    };

    vm.getDomainValues = function(field) {
      // console.log('field', field);
      return _.find(vm.fields, {
        'name': field
      }).domain.codedValues;
    };

    function _setSelected(step) {
      for (let key in vm.selected) {
        if (key === step) {
          vm.selected[key] = true;
        } else {
          vm.selected[key] = false;
        }
      }
    }

    // jshint ignore:start
    function _formatDate(date) {
      return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }

    function _formatStartQueryDate(date) {
      let newDate = new Date(date);
      return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate() + ' 00:00:00';
    }

    function _formatEndQueryDate(date) {
      let newDate = new Date(date);
      return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate() + ' 23:59:59';
    }

    //  Runs through the available fields for the selected report type and adds a param if it is defined.
    function _processParams() {
      let params = {},
        fields = vm.type.fields;
      for (let field in fields) {
        if (fields.hasOwnProperty(field)) {
          if (fields[field]) {
            //        console.log('field, vm.params[field]: ',field, vm.params[field]);
            params[field] = vm.params[field];
          }
        }
      }
      return params;
    }

    // jshint ignore:end
  }
})();
